import { render, staticRenderFns } from "./InspectionInfoList.vue?vue&type=template&id=8a90e438&scoped=true"
import script from "./InspectionInfoList.vue?vue&type=script&lang=js"
export * from "./InspectionInfoList.vue?vue&type=script&lang=js"
import style0 from "./InspectionInfoList.vue?vue&type=style&index=0&id=8a90e438&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a90e438",
  null
  
)

export default component.exports